import '@babel/polyfill';
import Axios from 'axios';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { axiosHelper } from '@dealersocket/react-common';
import { theme } from '@dealersocket/ds-ui-react/theme';
import { ThemeProvider } from '@dealersocket/ds-ui-react/theme/ThemeProvider';
import { getSessionProduct } from './shared/utils/helpers';
import { checkWebPFeature } from './shared/utils/web-browser-helper';
import { configureStore } from './store/configureStore';
import * as RoutesModule from './routes';
// import { registerServiceWorker } from './registerServiceWorker';

const { routes } = RoutesModule;
const appAxios = Axios.create({ headers: { Pragma: 'no-cache' } });
axiosHelper.setAxios(appAxios);

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl || undefined });

checkWebPFeature('lossy', (feature, isSupported) => {
  // Get the application-wide store instance, prepopulating with state from the server where available.
  const initialState = {
    common: { product: getSessionProduct(), webPSupported: isSupported },
    alert: {},
    commonForm: { dataModel: {}, isSubmitting: false },
  };
  const store = configureStore(history, initialState);

  theme.overrides = {
    ...theme.overrides,
    MuiFormControl: {
      ...(theme.overrides && theme.overrides.MuiFormControl),
      root: {
        ...(theme.overrides &&
          theme.overrides.MuiFormControl &&
          theme.overrides.MuiFormControl.root),
        height: 55,
      },
    },
  };

  ReactDOM.render(
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <IntlProvider locale={navigator.language} defaultLocale="en">
          <ConnectedRouter history={history}>{routes}</ConnectedRouter>
        </IntlProvider>
      </ThemeProvider>
    </Provider>,
    document.getElementById('root')
  );

  // registerServiceWorker();
});
